// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_7d20f514","headline":"rdg_1bff0a2c","list":"rdg_98ce1d9a","open":"rdg_41edac65","line":"rdg_4ccc241e","footer":"rdg_113105d1"};